<template>
    <form class="flex flex-col pt-3 md:pt-8" :class="theme" @submit.prevent="handleSubmit">
        <div class="flex flex-col pt-4" data-cy="code_field">
            <ui-label for="code">
                {{ $t('auth.form.fields.code') }}
            </ui-label>
            <ui-input
                v-model="v$.tfa_code.code.$model"
                data-cy="code"
                id="code"
                :class="{ 'form-error': v$.tfa_code.code.$error }"
            />
            <span class="text-help" v-if="method.type == 'app'">
                {{ $t('auth.form.help.app') }}
            </span>
            <div
                :class="{ 'text-default-red': v$.tfa_code.code.$error }"
                data-cy="code_field-error"
                v-if="v$.tfa_code.code.required.$invalid && v$.tfa_code.code.$error"
            >
                {{ $t('validation.required') }}
            </div>
            <validation-errors :errors="validation.errors.code" v-if="validation.errors" />
        </div>

        <p class="text-default-red text-center pt-4" data-cy="form-error-messages" v-if="validation.message">
            {{ validation.message }}
        </p>

        <ui-submit-button data-cy="submit_button" class="auth-button" :disabled="processing">
            <span v-if="!processing">
                {{ $t('auth.form.buttons.login') }}
            </span>
            <span v-else>
                {{ $t('auth.form.buttons.logging_in') }}
            </span>
        </ui-submit-button>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiLabel,
        UiSubmitButton,
        ValidationErrors,
    },
    validations: {
        tfa_code: {
            code: {
                required,
            },
        },
    },
    props: ['tfa_code', 'validation', 'processing', 'method', 'theme'],
    methods: {
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit');
        },
    },
};
</script>
